import React from "react";
import { Link } from "react-router-dom";
import { Mail, HelpCircle } from "lucide-react";
import QuietMarketingLayout, {
  QuietPrimaryButton,
  QuietTextLink,
} from "../components/QuietMarketingLayout";

export default function SupportPage() {
  return (
    <QuietMarketingLayout
      title="Support"
      description="Need help with an event, host account, or RSVP? Contact our support team below."
      backTestId="support-back-link"
      brandTestId="support-brand-link"
    >
      <section className="rounded-2xl border border-black/[0.04] bg-white p-5 sm:p-6 mb-3">
        <div className="flex items-start gap-3">
          <Mail className="w-4 h-4 shrink-0 mt-1 text-ink/40" strokeWidth={2} aria-hidden />
          <div className="min-w-0">
            <h2 className="font-ui font-semibold text-[17px] sm:text-[18px] leading-snug text-ink">Email us</h2>
            <p className="mt-2 text-[15px] font-normal text-ink/65 leading-relaxed text-pretty">
              Send bug reports, feature requests, or account questions to:
            </p>
            <a
              href="mailto:flipflopapps@gmail.com"
              className="mt-4 inline-block font-ui font-semibold text-[16px] sm:text-[17px] text-ink underline underline-offset-4 decoration-ink/20 hover:decoration-ink/50 transition-colors"
              data-testid="support-email-link"
            >
              flipflopapps@gmail.com
            </a>
          </div>
        </div>
      </section>

      <section className="rounded-2xl border border-black/[0.04] bg-white p-5 sm:p-6 mb-12">
        <div className="flex items-start gap-3">
          <HelpCircle className="w-4 h-4 shrink-0 mt-1 text-ink/40" aria-hidden strokeWidth={2} />
          <div className="min-w-0">
            <h2 className="font-ui font-semibold text-[17px] sm:text-[18px] leading-snug text-ink">
              How it works
            </h2>
            <p className="mt-2 text-[15px] font-normal text-ink/65 leading-relaxed text-pretty">
              Find and RSVP to local dance events in one central place. No lost WhatsApp messages or
              expiring Instagram stories.
            </p>
            <QuietTextLink to="/faq" className="mt-3 inline-block" data-testid="support-faq-link">
              Browse the FAQ →
            </QuietTextLink>
          </div>
        </div>
      </section>

      <section className="pt-2 pb-4 text-center sm:text-left">
        <p className="font-display font-semibold text-[18px] sm:text-[20px] text-ink text-balance">
          Find your next dance night.
        </p>
        <p className="mt-1.5 text-[14px] font-normal text-ink/55">Browse socials, reserve your spot, and dance.</p>
        <div className="mt-5">
          <QuietPrimaryButton as={Link} to="/#events" data-testid="support-browse-events-btn">
            Find Events →
          </QuietPrimaryButton>
        </div>
      </section>
    </QuietMarketingLayout>
  );
}
